import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { inject } from 'vue'
import CheckListItem from './CheckListItem.vue'

interface Props {
  /** Checklist items */
  items?: string[]
  /** Icon to display */
  icon?: string
  /** Icon color */
  color?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'CheckList'
},
  __name: 'CheckList',
  props: {
    items: { default: () => ([]) },
    icon: { default: () => (undefined) },
    color: { default: () => (undefined) }
  },
  setup(__props: any) {





const isMobileApp = inject('isMobileApp', false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(["flex flex-col", _unref(isMobileApp) ? 'gap-1' : 'gap-2'])
  }, [
    _renderSlot(_ctx.$slots, "default", { items: __props.items }, () => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, key) => {
        return _renderSlot(_ctx.$slots, "item", {
          key: key,
          item: item
        }, () => [
          _createVNode(CheckListItem, {
            item: item,
            icon: __props.icon,
            color: __props.color
          }, null, 8, ["item", "icon", "color"])
        ])
      }), 128))
    ])
  ], 2))
}
}

})